import React from 'react';
import { withStyles } from '@material-ui/core/styles';
// import {DialogActions, DialogContentText, Tooltip } from '@mui/material';
// import Dialog from '@material-ui/core/Dialog';
import { LoadingButton } from '@mui/lab';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import CheckQuestionCounter from './CheckQuestionCounter';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

// const DialogTitle = withStyles(styles)((props) => {
//   const { children, classes, onClose, ...other } = props;
//   return (
//     <MuiDialogTitle disableTypography className={classes.root} {...other}>
//       <Typography variant="h6">{children}</Typography>
//       {onClose ? (
//         <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
//           <CloseIcon />
//         </IconButton>
//       ) : null}
//     </MuiDialogTitle>
//   );
// });

// const DialogContent = withStyles((theme) => ({
//   root: {
//     padding: theme.spacing(2),
//   },
// }))(MuiDialogContent);

export default function CustomizedDialogs(props) {
  const userObj = useSelector(state => state.userDetails);
  ///const [open, setOpen] = React.useState(false);
  const childRefQuestionCounter = React.useRef();
  const [topicQuestionCountList, setTopicQuestionCountList] = React.useState([]);
  const [checkCountLoadingFlag, setCheckCountLoadingFlag] = React.useState(false);
  const [diffList, setDiffList] = React.useState([]);
  // const [severityAlert, setSeverityAlert] = React.useState("error");
  // const [showAlert, setShowAlert] = React.useState(false);
  // const [alertMessage, setAlertMessage] = React.useState("");
  // const [saveLoading, setSaveLoading] = React.useState(false);
  // const [apiDataLoading, setApiDataLoading] = React.useState(true);
  
  // const [questionTypeList, setQuestionTypeList] = React.useState([]);
  // const [topicsList, setTopicsList] = React.useState([]);
  
  // const [difficultyList, setDifficultyList] = React.useState([]);
  // const [gradeList, setGradeList] = React.useState([]);

  // const [sectionId, setSectionId] = React.useState(0);
  // const [sectionName, setSectionName] = React.useState("");
  // //const [topicId, setTopicId] = React.useState(0);
  // const [topicName, setTopicName] = React.useState("");
  // const [difficultyId, setDifficultyId] = React.useState(0);
  // const [difficultyName, setDifficultyName] = React.useState("Any");
  // const [gradeId, setGradeId] = React.useState(0);
  // const [gradeName, setGradeName] = React.useState("Any");
  // const [questionTypeId, setQuestionTypeId] = React.useState(1);
  // const [questionType, setQuestionType] = React.useState("Multiple Choice");
  // const [noOfQuestions, setNoOfQuestions] = React.useState(1);
  // const [searchRecursivelyChk, setSearchRecursivelyChk] = React.useState(false);

  function checkAvailability(){
    	if(!props.topicId){
        return false;
      }	
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 			
      let qryStr="?topicId="+props.topicId;
      if(props.treeviewTemplateId && props.treeviewTemplateId>0){
        qryStr+="&treeviewTemplateId="+props.treeviewTemplateId;
      }
      // if(props.examType){
      //   qryStr+="&examType="+props.examType;
      // }
      if(props.searchRecursively && props.searchRecursively===true){
        qryStr+="&searchRecursively=1";
      }else{
        qryStr+="&searchRecursively=0"; 
      }      
      if(props.difficultyIds && props.difficultyIds.length>0 && props.difficultyIds!=="0"){
        qryStr+="&difficultyIds="+props.difficultyIds;
      }
      if(props.gradeId && props.gradeId>0){
        qryStr+="&gradeId="+props.gradeId;
      }
      if(props.questionTypeIds && props.questionTypeIds.length>0 && props.questionTypeIds!=="0"){
        qryStr+="&questionTypeIds="+props.questionTypeIds;
      }
      setCheckCountLoadingFlag(true);
      axios.get(env.API_URL+"/exams/read/topics-question-count-chart"+qryStr, axiosHeader) 
			   .then(response => {
          setCheckCountLoadingFlag(false);
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="success"){		
          //document.write(JSON.stringify(response.data.obj));		

          if(response.data?.obj){
					  setTopicQuestionCountList(response.data?.obj?.list);
            setDiffList(response.data?.obj?.listTwo);
          }
          childRefQuestionCounter.current.handleClickOpen();
				}		
			}).catch((error) => {
				alert("ERROR: ", error);
			})	

  }

  

  return (
    <>
     {checkCountLoadingFlag?
      <LoadingButton loading={checkCountLoadingFlag} loadingPosition='start' startIcon={<div style={{marginRight:15}}></div>} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="contained"  >Counting...</LoadingButton>
     :<Button onClick={() => {checkAvailability()}} size="small" variant={props.variant} >Check Availability</Button>
     }
    <CheckQuestionCounter topicName={props.topicName} topicQuestionCountList={topicQuestionCountList} diffList={diffList} ref={childRefQuestionCounter} />
    </>
  );
}
